// Het wisselen tussen iOS en Android in het koppelblok.
//
// Wat dit script wel doet: van paneel wisselen. Wat het niet doet: de inhoud
// opbouwen. Allebei de panelen staan al in de pagina, met de stappen erin.
// Hapert dit script, dan zie je iOS en is er niets kapot; de knoppen doen dan
// alleen niets.
//
// Bewust geen tijdklok zoals in het uitlegblok. Daar bladert de sectie vanzelf
// door omdat je vier dingen achter elkaar laat zien. Hier is het een keuze:
// iemand heeft een iPhone of een Android, en die keuze moet blijven staan zolang
// hij kijkt.

class KoppelBlok extends HTMLElement {
  connectedCallback() {
    this.knoppen = [...this.querySelectorAll('[role="tab"]')];
    this.panelen = [...this.querySelectorAll('[role="tabpanel"]')];
    if (this.knoppen.length < 2) return;

    this.huidig = 0;

    this.knoppen.forEach((knop, i) => {
      knop.addEventListener("click", () => this.naar(i));
      knop.addEventListener("keydown", (e) => this.toets(e, i));
    });
  }

  naar(i) {
    if (i === this.huidig) return;

    this.knoppen[this.huidig].classList.remove("koppelen__knop--aan");
    this.knoppen[this.huidig].setAttribute("aria-selected", "false");
    this.knoppen[this.huidig].tabIndex = -1;
    this.panelen[this.huidig].hidden = true;

    this.huidig = i;

    this.knoppen[i].classList.add("koppelen__knop--aan");
    this.knoppen[i].setAttribute("aria-selected", "true");
    this.knoppen[i].tabIndex = 0;
    this.panelen[i].hidden = false;
    this.knoppen[i].focus();
  }

  // Pijltjes naar links en rechts lopen door de knoppen, zoals het hoort bij een
  // tablist. Met er maar twee is dat heen en weer.
  toets(e, i) {
    const laatste = this.knoppen.length - 1;
    let doel = null;
    if (e.key === "ArrowRight") doel = i === laatste ? 0 : i + 1;
    if (e.key === "ArrowLeft") doel = i === 0 ? laatste : i - 1;
    if (e.key === "Home") doel = 0;
    if (e.key === "End") doel = laatste;
    if (doel === null) return;
    e.preventDefault();
    this.naar(doel);
  }
}

if (!customElements.get("koppel-blok")) {
  customElements.define("koppel-blok", KoppelBlok);
}
